import { useEffect, useRef } from "react";
import { RichContent } from "./RichContent";

/**
 * RichContent + ulkoisille linkeille: target=_blank, sininen → violetti klikkauksen jälkeen.
 * Tila tallennetaan localStorageen avaimella `lnk:<href>`.
 */
export const RichContentWithLinks = ({
  html,
  className,
}: {
  html: string;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const anchors = root.querySelectorAll<HTMLAnchorElement>("a[href]");
    const handlers: Array<{ el: HTMLAnchorElement; fn: () => void }> = [];

    anchors.forEach((a) => {
      const href = a.getAttribute("href") || "";
      if (/^https?:\/\//i.test(href)) {
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener noreferrer");
      }
      const key = `lnk:${href}`;
      let clicked = false;
      try {
        clicked = localStorage.getItem(key) === "1";
      } catch {
        // ignore
      }
      a.dataset.clicked = clicked ? "1" : "0";
      const fn = () => {
        try {
          localStorage.setItem(key, "1");
        } catch {
          // ignore
        }
        a.dataset.clicked = "1";
      };
      a.addEventListener("click", fn);
      handlers.push({ el: a, fn });
    });

    return () => {
      handlers.forEach(({ el, fn }) => el.removeEventListener("click", fn));
    };
  }, [html]);

  return (
    <div
      ref={ref}
      className={`[&_a]:no-underline [&_a]:text-[#1d4ed8] [&_a[data-clicked='1']]:text-[#7e22ce] [&_a:hover]:opacity-80 ${className ?? ""}`}
    >
      <RichContent html={html} />
    </div>
  );
};
